'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$() {
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ as $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ as $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ };
$h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$.prototype = $p;
$p.l = (function() {
  return "LocalPjeOfficeSignFileBase64Request";
});
$p.cFV = (function(x$0) {
  return new $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest.$c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$, "presto.AgentView$LocalPjeOfficeSignFileBase64Request$", ({
  Ei: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ as $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ };
var $n_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$;
function $m_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$() {
  if ((!$n_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$)) {
    $n_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ = new $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$();
  }
  return $n_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$;
}
export { $m_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ as $m_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$ };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Request$.js.map
